export interface SearchSeparateDictionaryRequest {
  name: string
}

export function SearchSeparateDictionaryRequestToJSON(
  value: SearchSeparateDictionaryRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined
  }
}
